module.exports = __webpack_public_path__ + "static/media/envelope.7ec263f2.svg";